import apiClient, { extractData } from '../api-client';

export const settingsApi = {
  get() {
    return apiClient.get('/settings').then(extractData);
  },
  update(data) {
    return apiClient.patch('/settings', data).then(extractData);
  },
  // QR chuyển khoản (data URL base64) theo mã đơn — sinh phía server, nội dung CK có mã đơn.
  // Trả null nếu chưa cấu hình ngân hàng hoặc tải QR thất bại.
  getPaymentQr(orderCode = '') {
    return apiClient
      .get('/settings/payment-qr', { params: { order_code: orderCode } })
      .then(extractData)
      .then((d) => d?.qr_base64 ?? null);
  },
  // Token bảng đơn đang sản xuất (nút 'QR xưởng'). FE tự ghép link đầy đủ
  // `<origin>/production-board?t=<token>` từ origin của chính nó.
  getProductionBoardLink() {
    return apiClient.get('/settings/production-board-link').then(extractData);
  },
  // QR hoàn thành SX (tab Cài đặt > QR xưởng, chỉ admin). Trả
  // { token, path, network_lock, your_ip }; FE ghép `<origin><path>?t=<token>`.
  getFactoryQrLink() {
    return apiClient.get('/settings/factory-qr-link').then(extractData);
  },
  // Tạo mã mới — tem đang dán chết ngay.
  rotateFactoryQrLink() {
    return apiClient.post('/settings/factory-qr-link/rotate').then(extractData);
  },
  // Bật/tắt kiểm tra wifi riêng cho QR hoàn thành SX. Trả { network_lock }.
  setFactoryQrNetwork(enabled) {
    return apiClient.put('/settings/factory-qr-network', { network_lock: enabled }).then(extractData);
  },
  // Token màn hình TV realtime (mục 'Màn hình TV' ở Cài đặt). FE tự ghép link
  // `<origin>/tv-dashboard?t=<token>` để mở trên tivi hoặc sinh QR.
  getTvDashboardLink() {
    return apiClient.get('/settings/tv-dashboard-link').then(extractData);
  },
  // Khoá/mở màn hình TV (cả 2 link). Đường ghi riêng vì có ghi nhật ký — PATCH
  // /settings không nhận field này. Trả { tv_locked }.
  setTvLock(locked) {
    return apiClient.put('/settings/tv-lock', { tv_locked: locked }).then(extractData);
  },
  // Thêm 1 âm custom vào danh sách của 1 hiệu ứng → trả { effect, config }.
  uploadTvSound(effect, file) {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient
      .post(`/settings/tv-sound/${effect}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(extractData);
  },
  // Xóa 1 âm custom khỏi danh sách hiệu ứng.
  deleteTvSoundItem(effect, url) {
    return apiClient
      .delete(`/settings/tv-sound/${effect}/item`, { params: { url } })
      .then(extractData);
  },
  // Cập nhật chế độ / lựa chọn / danh sách bật của 1 hiệu ứng.
  updateTvSound(effect, body) {
    return apiClient.patch(`/settings/tv-sound/${effect}`, body).then(extractData);
  },
};
